import { getSnapshotOptionTitle } from 'components/SelectSnapshot/getSnapshotOptionTitle';
import type { Snapshot } from 'pages/SnapshotManagement/snapshotManagementTypes';
import { memo } from 'react';
import type { FC } from 'react';

import { SnapshotLabel } from 'components/SnapshotLabel/SnapshotLabel';
import { type OptionProps, components } from 'react-select';

type Props = OptionProps<Snapshot>;

const BareSelectSnapshotOption: FC<Props> = (props) => {
  const snapshot: Snapshot = props.data;
  const hasError = snapshot.status === 'error';

  return (
    <components.Option {...props}>
      <div className='select-snapshot-option__item-wrapper'>
        <SnapshotLabel
          disabled={props.isDisabled}
          name={getSnapshotOptionTitle(
            snapshot.name,
            snapshot.status === 'canceled',
          )}
          date={snapshot.tsStart}
          error={hasError}
          compact
        />
        <span className='select-snapshot-option__spinner-wrapper'>
          {snapshot.running ? (
            <i className='fa-regular fa-spinner fa-spin' />
          ) : null}
        </span>
      </div>
    </components.Option>
  );
};

export const SelectSnapshotOption = memo(BareSelectSnapshotOption);
